import React from 'react'
// import CardItem from '../../CardItem'
import './style.scss'


const CardView = ({ dataList, setDataListFromItem, customProps, theme, dataListToDisplay,
  //  options, 
  columns }) => {


  const body = (item, index) => {
    return <div  >
      {columns.map((col, idx) => {
        if (col.component) {
          return (<div key={idx}>{col.component({ item, index, dataList, setDataListFromItem, ...customProps })}</div>)
        } else {
          let className = '';
          if (col.rowClassName && Array.isArray(col.rowClassName)) {
            col.rowClassName.map(_item => {
              if (item[_item.property] === _item.value) {
                className += _item.className
              }
            })
          }
          return (<div className='d-flex justify-content-between' key={idx}>  <label>{col.title}</label>
            <span className={className}>{item[col.property]}</span></div>)
        }

      }
      )}

    </div>
  }
  return (
    <div className='card-view-container' id="gsfTable">
      {dataListToDisplay.map((item, idx) =>
        <CardItem key={idx} InternalNo={100 + idx + 1} body={body(item, idx)} theme={theme} />
      )}
      {dataList.length === 0 &&
        <CardItem InternalNo={0} body={(() => { return <div>No item to display</div> })()} />
      }

    </div>
  )
}

export default CardView

const CardItem = ({ options, body, theme = "" }) => {
  return (
    <div className={`card-item ${theme}`}  >
      {body}

    </div>
  )
}